import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1179cb50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-background row items-center justify-center window-height" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 text-center text-secondary" }, " Château Cazalères ", -1))
const _hoisted_3 = { class: "text-h5 text-center text-primary" }
const _hoisted_4 = { class: "row flex-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-grey" }, " | ", -1))
const _hoisted_6 = { class: "text-caption text-grey text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_errors = _resolveComponent("errors")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_password_forgotten_dialog = _resolveComponent("password-forgotten-dialog")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "sign-in-card col-xs-10" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('Ownersportal')), 1)
              ]),
              _: 1
            }),
            (_ctx.errors.length > 0)
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_errors, { errors: _ctx.errors }, null, 8, ["errors"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_form, { onSubmit: _ctx.signIn }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_input, {
                      ref: "emailInputRef",
                      modelValue: _ctx.emailInput,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailInput) = $event)),
                      type: "email",
                      label: _ctx.t('Email'),
                      class: "q-mb-md",
                      rules: [_ctx.required('Email'), _ctx.email],
                      "hide-bottom-space": "",
                      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errors = []))
                    }, null, 8, ["modelValue", "label", "rules"]),
                    _createVNode(_component_q_input, {
                      ref: "passwordRef",
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                      type: "password",
                      label: _ctx.t('Password'),
                      class: "q-mb-lg",
                      onKeydown: _withKeys(_ctx.signIn, ["enter"]),
                      rules: [_ctx.required('Password')],
                      "hide-bottom-space": "",
                      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errors = []))
                    }, null, 8, ["modelValue", "label", "onKeydown", "rules"]),
                    _createVNode(_component_q_btn, {
                      label: _ctx.t('Sign in'),
                      class: "full-width q-mb-md",
                      color: "secondary",
                      loading: _ctx.isLoading,
                      type: "submit"
                    }, null, 8, ["label", "loading"])
                  ]),
                  _: 1
                }, 8, ["onSubmit"]),
                _createVNode(_component_password_forgotten_dialog)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_q_btn, {
                    label: "FR",
                    color: "grey",
                    flat: "",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLang('fr')))
                  }),
                  _hoisted_5,
                  _createVNode(_component_q_btn, {
                    label: "NL",
                    color: "grey",
                    flat: "",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setLang('nl')))
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, " Focus Platforms - © " + _toDisplayString(new Date().getFullYear()), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}